import { AVATAR_COLOR_CLASSES } from '../constants';

/** Returns up to 2 uppercase initials from a display name. */
export const getInitials = (name: string): string =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');

/** Deterministically picks an avatar background class from a name. */
export const generateAvatarColorClass = (name: string): string => {
  if (!name) return AVATAR_COLOR_CLASSES[0];
  const index = name.charCodeAt(0) % AVATAR_COLOR_CLASSES.length;
  return AVATAR_COLOR_CLASSES[index];
};

/** Converts a unix-seconds timestamp into a `YYYY-MM-DD` date string. */
export const unixToDateString = (unix: number | string | undefined): string => {
  if (!unix) return '';
  return new Date(Number(unix) * 1000).toISOString().split('T')[0];
};

/** Computes a usage-bar width percentage from used/total display strings. */
export const toUsagePercent = (used: string, total: string): number => {
  const usedValue = parseFloat(used.replace(',', ''));
  const totalValue = parseFloat(total.replace(',', ''));
  if (!totalValue) return 0;
  return (usedValue / totalValue) * 100;
};
